import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Login from "./Login";
import ResetPassword from "./ResetPassword";
import store, { Message } from "../services/store";
import Toastify from "toastify-js";

export default () => {
  // Enregistrer les notifications au niveau de l'app
  store.listen(Message.Error, (msg) =>
    Toastify({
      text: msg,
      duration: 3000,
      stopOnFocus: true,
      backgroundColor: ' #fc7169',
    }).showToast()
  );

  store.listen(Message.Notification, (msg) =>
    Toastify({
      text: msg,
      duration: 3000,
      stopOnFocus: true,
      backgroundColor: '#4dce76',
    }).showToast()
  );

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/reset_password/:token">
          <ResetPassword />
        </Route>
        <Route path="/reset_password">
          <ResetPassword />
        </Route>
        <Route path="/">
          <Login />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};
